import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';

import { api } from '../api/client';
import { bindQueryOnlineManager, connectivityMiddleware } from '../api/connectivity';
import { installOfflineSession, isOfflineSession, subscribeOfflineSession } from '../api/offlineSession';
import { createPersistOptions } from '../api/persistence';
import { queryClient } from '../api/queryClient';
import { installSessionWatch } from '../api/sessionWatch';
import { routes } from './routes';

// Antes de crear el router (su loader recupera la sesión apenas se crea):
// - cada respuesta o error de red del API dice si hay conexión de verdad (S01 "Sin conexión");
// - la sesión sin conexión recuerda quién entró y abre sus datos guardados si no hay red;
// - TanStack Query deja las consultas en pausa sin conexión y las retoma al volver;
// - la sesión se renueva antes de vencer y, si el API la rechaza, la app abre el ingreso.
api.use(connectivityMiddleware);
installOfflineSession(queryClient);
installSessionWatch();
bindQueryOnlineManager(isOfflineSession, subscribeOfflineSession);

const router = createBrowserRouter(routes);
/** Lo último guardado (consultas con `meta: { persist: true }`) se restaura antes de pedir datos. */
const persistOptions = createPersistOptions();

export function App() {
  return (
    <PersistQueryClientProvider client={queryClient} persistOptions={persistOptions}>
      <RouterProvider router={router} />
    </PersistQueryClientProvider>
  );
}
